import axios from "axios";

import authService from "./auth.service";

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL+"/articles/";

const get = (uri, params) => {
  return axios.get(API_URL + uri, { headers: authService.header(), params: { ...params}  });
};

const getOne = (params) => {
  return axios.get(window.__RUNTIME_CONFIG__.REACT_APP_API_URL + "/article", { headers: authService.header(), params: { ...params}  });
};

const getAll = (params) => {
  return axios.get(window.__RUNTIME_CONFIG__.REACT_APP_API_URL + "/articles", { headers: authService.header(), params: { ...params}  });
};

const add = (data, uri='') => {
  return axios.post(API_URL + uri + "add", data, {
    headers: authService.header()
  });
};

const edit = (data, uri='') => {
  return axios.post(API_URL + uri + "edit", data, {
    headers: authService.header()
  });
};

const remove = (data, uri='') => {
  return axios.post(API_URL + uri + "delete", data, {
    headers: authService.header()
  });
};

const uploadPhotos = (data, setProgress) => {
  return axios.post(API_URL + "upload", data, {
    headers: authService.header(),
    onUploadProgress: (progressEvent) => {
      const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
      if (totalLength !== null)
        setProgress(Math.round( (progressEvent.loaded * 100) / totalLength ));
    }
  });
};

export default {
  get,
  getOne,
  getAll,
  uploadPhotos,
  add,
  edit,
  remove
};
